module.exports = __webpack_public_path__ + "img/no-data.1d10f376.svg";